export const FORMS: any[] = [
    {
        "name" : "EditBlogRest",
        "altTarget" : [ {
          "useWhen" : "contentId==null",
          "targetExdr" : {
            "chars" : "newBlog",
            "hint" : 20,
            "empty" : false,
            "original" : "newBlog"
          }
        } ],
        "formLocation" : "component://content/widget/forum/BlogForms.xml",
        "fields" : [ {
          "conditionGroup" : "",
          "name" : "contentId",
          "action" : "",
          "id" : "EditBlog_contentId",
          "type" : "hidden",
          "event" : "",
          "value" : ""
        }, {
          "conditionGroup" : "",
          "name" : "contentTypeId",
          "action" : "",
          "id" : "EditBlog_contentTypeId",
          "type" : "hidden",
          "event" : "",
          "value" : "WEB_SITE_PUB_PT"
        }, {
          "conditionGroup" : "",
          "name" : "contentIdFrom",
          "action" : "",
          "id" : "EditBlog_contentIdFrom",
          "type" : "hidden",
          "event" : "",
          "value" : "BLOGROOT"
        }, {
          "conditionGroup" : "",
          "name" : "contentAssocTypeId",
          "action" : "",
          "id" : "EditBlog_contentAssocTypeId",
          "type" : "hidden",
          "event" : "",
          "value" : "SUB_CONTENT"
        }, {
          "" : "",
          "fieldHelpText" : "",
          "textSize" : "30",
          "ajaxUrl" : "",
          "maxlength" : "60",
          "tabindex" : "",
          "className" : "",
          "title" : "Blog Name",
          "type" : "text",
          "clientAutocomplete" : "true",
          "ajaxEnabled" : true,
          "readonly" : false,
          "alert" : "false",
          "name" : "contentName",
          "action" : "",
          "style" : "",
          "disabled" : false,
          "id" : "EditBlog_contentName",
          "placeholder" : "",
          "event" : "",
          "value" : "",
          "mask" : ""
        }, {
          "" : "",
          "fieldHelpText" : "",
          "textSize" : "30",
          "ajaxUrl" : "",
          "maxlength" : "60",
          "tabindex" : "",
          "className" : "",
          "title" : "Blog Description",
          "type" : "text",
          "clientAutocomplete" : "true",
          "ajaxEnabled" : true,
          "readonly" : false,
          "alert" : "false",
          "name" : "description",
          "action" : "",
          "style" : "",
          "disabled" : false,
          "id" : "EditBlog_description",
          "placeholder" : "",
          "event" : "",
          "value" : "",
          "mask" : ""
        }, 
        {
          "buttonType" : "button",
          "alert" : "false",
          "formName" : "EditBlogRest",
          "tabindex" : "",
          "name" : "submitButton",
          "className" : "",
          "id" : "EditBlog_submitButton",
          "confirmation" : "",
          "type" : "SUBMIT",
          "title" : "CommonSubmit",
          "event" : "",
          "imgSrc" : ""
        } ],
        "target" : "updateBlog",
        "targets" : {
          createTarget:"newBlog",
          updateTarget:"updateBlog"
        }
      },
      {
        "name":"EditBlog",
        "target": "updateBlog",
        "targetWindow": "",
        "fields": [
          {
            "title": "Content Id",
            "name": "contentId",
            "value": "",
            "id": "EditBlog_contentId",
            "event": "",
            "required": false,
            "type": "hidden"
          },
          {
            "title": "Content Assoc Type Id",
            "name": "contentAssocTypeId",
            "value": "SUB_CONTENT",
            "id": "EditBlog_contentAssocTypeId",
            "event": "",
            "required": false,
            "type": "hidden"
          },
          {
            "title": "ContentBlogName",
            "name": "contentName",
            "value": "",
            "id": "EditBlog_contentName",
            "event": "",
            "required": false,
            "type": "text"
          },
          {
            "title": "ContentBlogDescription",
            "name": "description",
            "value": "",
            "id": "EditBlog_description",
            "event": "",
            "required": false,
            "type": "text"
          },
          {
            "title": "Submit",
            "name": "submitButton",
            "value": "",
            "id": "EditBlog_submitButton",
            "event": "",
            "required": false,
            "type": "submit"
          }
        ]
      },
      {
        "name":"ListBlogsRest",
        "target": "",
        "targetWindow": "",
        "fields": [
          {
            "title": "Content Id",
            "name": "contentId",
            "value": "",
            "id": "ListBlogs_contentId",
            "event": "",
            "required": false,
            "type": "hidden"
          },
          {
            "title": "Blog Name",
            "name": "contentName",
            "value": "",
            "id": "ListBlogs_contentName",
            "event": "list",
            "required": true,
            "type": "hyperlink",
            "target": "editBlog",
            "parameterList": [
              {
                "name": "blogContentId",
                "fromField": {
                  "isEmpty": false,
                  "original": "contentId",
                  "bracketedOriginal": "${contentId}",
                  "isAscending": true
                }
              }
            ],
            "formData":{
              "formName":"ListBlogContent",
              "formLocation":"component://content/widget/forum/BlogForms.xml",
              "viewIndex":1,
              "endPoint":"listFindBlogContent"
            }
          },
          {
            "title": "Description",
            "name": "description",
            "value": "",
            "id": "ListBlogs_description",
            "event": "",
            "required": false
          },
          {
            "title": "Status ID",
            "name": "statusId",
            "value": "",
            "id": "ListBlogs_statusId",
            "event": "",
            "required": false,
            "type": "display-entity",
            "entityName": "StatusItem",
            "description": ""
          },
          {
            "title": "Locale String",
            "name": "localeString",
            "value": "",
            "id": "ListBlogs_localeString",
            "event": "",
            "required": false,
            "type": "display-entity",
            "entityName": "CountryCode",
            "description": ""
          },
          {
            "title": "Content Type Id",
            "name": "contentTypeId",
            "value": "",
            "id": "ListBlogs_contentTypeId",
            "event": "",
            "required": false,
            "type": "display-entity",
            "entityName": "ContentType",
            "description": ""
          },
          {
            "title": "Last Modified Date",
            "name": "lastModifiedDate",
            "value": "",
            "id": "ListBlogs_lastModifiedDate",
            "event": "",
            "required": false
          },
          {
            "title": "Last Modified By User Login",
            "name": "lastModifiedByUserLogin",
            "value": "",
            "id": "ListBlogs_lastModifiedByUserLogin",
            "event": "",
            "required": false
          },
        ]
      },
      {
        "name":"FindBlogContent",
        "target": "findBlogContent",
        "targetWindow": "",
        "fields": [
          {
            "title": "No Condition Find",
            "name": "noConditionFind",
            "value": "",
            "id": "FindBlogContent_noConditionFind",
            "event": "",
            "required": false,
            "type": "hidden"
          },
          {
            "title": "Content Assoc Type Id",
            "name": "caContentAssocTypeId",
            "value": "",
            "id": "FindBlogContent_caContentAssocTypeId",
            "event": "",
            "required": false
          },
          {
            "title": "Ca Thru Date",
            "name": "caThruDate",
            "value": "",
            "id": "FindBlogContent_caThruDate",
            "event": "",
            "required": false,
            "type": "hidden"
          },
          {
            "title": "ContentContentIdStart",
            "name": "contentIdStart",
            "value": "",
            "id": "FindBlogContent_contentIdStart",
            "event": "",
            "required": false,
            "type": "textqbe"
          },
          {
            "title": "Content Assoc Type Id",
            "name": "caContentAssocTypeId",
            "value": "",
            "id": "FindBlogContent_caContentAssocTypeId",
            "event": "",
            "required": false
          },
          {
            "title": "Find",
            "name": "searchButton",
            "value": "",
            "id": "FindBlogContent_searchButton",
            "event": "",
            "required": false,
            "type": "submit"
          }
        ]
      },
      {
        "fieldSets" : [ {
          "fieldSetName" : "Default",
          "fields" : [ "contentName", "description", "statusId", "createdDate" ]
        } ],
        "columns" : [ {
          "name" : "contentName",
          "title" : "Content Name"
        }, {
          "name" : "description",
          "title" : "Description"
        }, {
          "name" : "statusId",
          "title" : "Status ID"
        }, {
          "name" : "createdDate",
          "title" : "Created Date"
        } ],
        "formName" : "BlogArticles",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/WebSiteContentForms.xml",
        "type" : "list",
        "fields" : [ {
          "conditionGroup" : "",
          "name" : "contentId",
          "action" : "",
          "id" : "BlogEntries_contentId",
          "type" : "HIDDEN",
          "event" : "",
          "value" : ""
        }, {
          "image" : "",
          "fieldHelpText" : "",
          "alternate" : "",
          "description" : "",
          "title" : "Content Name",
          "type" : "HYPERLINK",
          "target" : "ViewBlogArticle",
          "name" : "contentName",
          "width" : "",
          "parameterList" : [ {
            "fromField" : {
              "isEmpty" : false,
              "original" : "contentId",
              "bracketedOriginal" : "${contentId}",
              "isAscending" : true,
              "empty" : false,
              "originalName" : "contentId"
            },
            "name" : "articleContentId"
          }, {
            "fromField" : {
              "isEmpty" : false,
              "original" : "parameters.blogContentId",
              "bracketedOriginal" : "${parameters.blogContentId}",
              "isAscending" : true,
              "empty" : false,
              "originalName" : "parameters.blogContentId"
            },
            "name" : "blogContentId"
          } ],
          "style" : "",
          "id" : "BlogEntries_contentName",
          "imageTitle" : "",
          "parameterMap" : { },
          "height" : "",
          "event":"edit",
            "formData":{
                "formName":"EditBlogArticle",
                "formLocation":"component://kwikstore/widget/StoreForms.xml",
            }
        }, {
          "fieldHelpText" : "",
          "ajaxEnabled" : false,
          "size" : 0,
          "name" : "description",
          "description" : "",
          "style" : "",
          "id" : "BlogEntries_description",
          "title" : "",
          "type" : "DISPLAY",
          "imageLocation" : ""
        }, {
          "fieldHelpText" : "",
          "ajaxEnabled" : false,
          "size" : 0,
          "name" : "statusId",
          "description" : "",
          "style" : "",
          "id" : "BlogEntries_statusId",
          "title" : "",
          "type" : "DISPLAY_ENTITY",
          "imageLocation" : ""
        }, {
          "fieldHelpText" : "",
          "ajaxEnabled" : false,
          "size" : 0,
          "name" : "createdDate",
          "description" : "",
          "style" : "",
          "id" : "BlogEntries_createdDate",
          "title" : "",
          "type" : "DISPLAY",
          "imageLocation" : ""
        } ],
        "target" : ""
      },
      {
        "name":"ListBlogContent",
        "target": "",
        "targetWindow": "",
        "fields": [
          {
            "title": "Content Id",
            "name": "contentId",
            "value": "",
            "id": "ListBlogContent_contentId",
            "event": "",
            "required": false,
            "type": "hidden"
          },
          {
            "title": "Content Name",
            "name": "contentName",
            "value": "",
            "id": "ListBlogContent_contentName",
            "event": "edit",
            "required": false,
            "type": "hyperlink",
            "target": "ViewBlogArticle",
            
            "parameterList": [
              {
                "name": "articleContentId",
                "fromField": {
                  "isEmpty": false,
                  "original": "contentId",
                  "bracketedOriginal": "${contentId}",
                  "isAscending": true
                }
              },
              {
                "name": "blogContentId",
                "fromField": {
                  "isEmpty": false,
                  "original": "contentIdStart",
                  "bracketedOriginal": "${blogContentId}",
                  "isAscending": true
                }
              }
            ],
            "formData":{
              "formLocation":"component://content/widget/forum/BlogForms.xml",
              "formName":"EditArticleRest",
              "endPoint":"view"
            }
          },
          {
            "title": "Description",
            "name": "description",
            "value": "",
            "id": "ListBlogContent_description",
            "event": "",
            "required": false
          },
          {
            "title": "Status ID",
            "name": "statusId",
            "value": "",
            "id": "ListBlogs_statusId",
            "event": "",
            "required": false,
            "type": "display-entity",
            "entityName": "StatusItem",
            "description": ""
          },
          {
            "title": "Locale String",
            "name": "localeString",
            "value": "",
            "id": "ListBlogs_localeString",
            "event": "",
            "required": false,
            "type": "display-entity",
            "entityName": "CountryCode",
            "description": ""
          },
          {
            "title": "Content Type Id",
            "name": "contentTypeId",
            "value": "",
            "id": "ListBlogs_contentTypeId",
            "event": "",
            "required": false,
            "type": "display-entity",
            "entityName": "ContentType",
            "description": ""
          },
    
        ]
      },
      {
        "name":"EditArticleRest",
        "target": "updateBlogArticle",
        "altTargets":[
          {
            useWhen:"contentId!=void&&contentId!=null",
            targetExdr:{
              original:"createBlogArticle"
            }
          }
        ],
        "targetWindow": "",
        "fields": [
          {
            "title": "Blog Content Id",
            "name": "blogContentId",
            "value": "",
            "id": "EditArticle_blogContentId",
            "event": "",
            "required": false,
            "type": "hidden"
          },
          {
            "title": "Content Id",
            "name": "contentId",
            "value": "",
            "id": "EditArticle_contentId",
            "event": "",
            "required": false,
            "type": "hidden"
          },
          {
            "title": "Title",
            "name": "contentName",
            "value": "",
            "id": "EditArticle_contentName",
            "event": "",
            "required": false,
            "type": "text"
          },
          {
            "title": "Description",
            "name": "description",
            "value": "",
            "id": "EditArticle_description",
            "event": "",
            "required": false,
            "type": "textarea",
            "useEditor":false
          },
          {
            "title": "Summary",
            "name": "summaryData",
            "value": "",
            "id": "EditArticle_summaryData",
            "event": "",
            "required": false,
            "type": "textarea",
            "useEditor":false
          },
          {
            "title": "Article",
            "name": "articleData",
            "value": "",
            "id": "EditArticle_articleData",
            "event": "",
            "required": false,
            "type": "textarea",
            "useEditor":true
          },
          {
            "title": "Image",
            "name": "uploadedFile",
            "value": "",
            "id": "EditArticle_uploadedFile",
            "event": "",
            "required": false,
            "type":"file"
          },
          {
            "title": "Template",
            "name": "templateDataResourceId",
            "value": "",
            "id": "EditArticle_templateDataResourceId",
            "event": "",
            "required": false,
            "type": "dropdown",
            "allOptionValues": [
              {
                "key": "BLOG_TPL_TOPLEFT",
                "description": "Top Left"
              },
              {
                "key": "BLOG_TPL_TOPCENTER",
                "description": "Center"
              }
            ],
            "textSize": 0
          },
          {
            "title": "Status",
            "name": "statusId",
            "value": "",
            "id": "EditArticle_statusId",
            "event": "",
            "required": false,
            "type": "dropdown",
            "allOptionValues": [
              {
                "key": "CTNT_PUBLISHED",
                "description": "Published"
              },
              {
                "key": "CTNT_INITIAL_DRAFT",
                "description": "Draft"
              }
            ],
            "textSize": 0
          },
          {
            "title": "Submit",
            "name": "submitButton",
            "value": "",
            "id": "EditArticle_submitButton",
            "event": "",
            "required": false,
            "type": "submit"
          }
        ]
      },
      {
        "name":"EditArticle",
        "target": "createBlogArticle",
        "targetWindow": "",
        "fields": [
          {
            "title": "Blog Content Id",
            "name": "blogContentId",
            "value": "",
            "id": "EditArticle_blogContentId",
            "event": "",
            "required": false,
            "type": "hidden"
          },
          {
            "title": "Article Name",
            "name": "contentName",
            "value": "",
            "id": "EditArticle_contentName",
            "event": "",
            "required": false,
            "type": "text"
          },
          {
            "title": "Description",
            "name": "description",
            "value": "",
            "id": "EditArticle_description",
            "event": "",
            "required": false,
            "type": "textarea"
          },
          {
            "title": "Summary",
            "name": "summaryData",
            "value": "",
            "id": "EditArticle_summaryData",
            "event": "",
            "required": false,
            "type": "textarea"
          },
          {
            "title": "Article",
            "name": "articleData",
            "value": "",
            "id": "EditArticle_articleData",
            "event": "",
            "required": false,
            "type": "textarea"
          },
          {
            "title": "Image",
            "name": "uploadedFile",
            "value": "",
            "id": "EditArticle_uploadedFile",
            "event": "",
            "required": false
          },
          {
            "title": "Template",
            "name": "templateDataResourceId",
            "value": "",
            "id": "EditArticle_templateDataResourceId",
            "event": "",
            "required": false,
            "type": "dropdown",
            "allOptionValues": [
              {
                "key": "BLOG_TPL_TOPLEFT",
                "description": "Top Left"
              },
              {
                "key": "BLOG_TPL_TOPCENTER",
                "description": "Top Center"
              }
            ],
            "textSize": 0
          },
          {
            "title": "Status",
            "name": "statusId",
            "value": "",
            "id": "EditArticle_statusId",
            "event": "",
            "required": false,
            "type": "dropdown",
            "allOptionValues": [
              {
                "key": "CTNT_PUBLISHED",
                "description": "Publish"
              },
              {
                "key": "CTNT_INITIAL_DRAFT",
                "description": "Preview"
              }
            ],
            "textSize": 0
          },
          {
            "title": "Submit",
            "name": "submitButton",
            "value": "",
            "id": "EditArticle_submitButton",
            "event": "",
            "required": false,
            "type": "submit"
          }
        ]
      },
      {
        "fieldSets" : [ {
          "fieldSetName" : "Default",
          "fields" : [ "contentName", "webSiteId", "fromDate", "thruDate" ]
        } ],
        "formName" : "BlogWebContent",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/WebSiteContentForms.xml",
        "type" : "single",
        "fields" : [ {
          "conditionGroup" : "",
          "name" : "contentId",
          "action" : "",
          "id" : "BlogWebContent_contentId",
          "type" : "HIDDEN",
          "event" : "",
          "value" : ""
        }, {
          "conditionGroup" : "",
          "name" : "contentName",
          "action" : "",
          "id" : "BlogWebContent_contentName",
          "title" : "Name",
          "type" : "DISPLAY",
          "event" : "",
          "value" : ""
        }, {
          "conditionGroup" : "",
          "name" : "fromDate",
          "action" : "",
          "id" : "BlogWebContent_fromDate",
          "title" : "From Date",
          "type" : "DISPLAY",
          "event" : "",
          "value" : ""
        }, {
          "fieldHelpText" : "",
          "ajaxEnabled" : false,
          "size" : 0,
          "name" : "webSiteId",
          "description" : "",
          "style" : "",
          "id" : "BlogWebContent_webSiteId",
          "title" : "Web Site ID",
          "type" : "DISPLAY",
          "imageLocation" : ""
        }, {
          "classString" : "",
          "shortDateInput" : "false",
          "ampmName" : "",
          "className" : "",
          "title" : "Thru Date",
          "type" : "DATE_TIME",
          "dateType" : "timestamp",
          "defaultDateTimeString" : "2024-09-09%2013:48:48.933",
          "timeDropdown" : "text",
          "alert" : "false",
          "timeValues" : "",
          "formName" : "BlogWebContent",
          "timeDropdownParamName" : "thruDate",
          "timeMinutesName" : "",
          "disabled" : "false",
          "id" : "BlogWebContent_thruDate",
          "event" : "",
          "value" : "",
          "pmSelected" : "",
          "localizedInputTitle" : "",
          "mask" : "",
          "hour1" : "0",
          "isTwelveHour" : "false",
          "fieldHelpText" : "",
          "hour2" : "0",
          "maxlength" : "30",
          "minutes" : "0",
          "tabindex" : "",
          "amSelected" : "",
          "size" : "25",
          "isXMLHttpRequest" : "false",
          "localizedIconTitle" : "",
          "timeHourName" : "",
          "name" : "thruDate",
          "style" : "",
          "step" : "1",
          "compositeType" : ""
        } ],
        "target" : "updateWebContent"
      },
      {
        "fieldSets" : [ {
          "fieldSetName" : "Default",
          "fields" : [ "partyId", "roleTypeId", "fromDate" ]
        } ],
        "columns" : [ {
          "name" : "partyId",
          "title" : "PartyPartyId"
        }, {
          "name" : "roleTypeId",
          "title" : "PartyRoleTypeId"
        }, {
          "name" : "fromDate",
          "title" : "From Date"
        } ],
        "formName" : "BlogRoles",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/WebSiteContentForms.xml",
        "type" : "list",
        "fields" : [ {
          "conditionGroup" : "",
          "name" : "contentId",
          "action" : "",
          "id" : "BlogRoles_contentId",
          "type" : "HIDDEN",
          "event" : "",
          "value" : ""
        }, {
          "hyperlink" : {
            "linkStyle" : "buttontext",
            "description" : "[]",
            "targetType" : "intra-app",
            "confirmation" : "",
            "parameterMap" : {
              "VIEW_SIZE_0" : "20",
              "VIEW_INDEX_0" : "0"
            },
            "uniqueItemName" : "Modal_70f823f2_a274_432d_99af_e9d4cf38bee8",
            "target" : "viewParty",
            "targetWindow" : ""
          },
          "fieldHelpText" : "",
          "ajaxEnabled" : false,
          "size" : 0,
          "name" : "partyId",
          "description" : "",
          "style" : "",
          "id" : "BlogRoles_partyId",
          "title" : "",
          "type" : "DISPLAY_ENTITY",
          "imageLocation" : ""
        }, {
          "fieldHelpText" : "",
          "ajaxEnabled" : false,
          "isSortField" : "Y",
          "size" : 0,
          "name" : "roleTypeId",
          "description" : "",
          "style" : "",
          "id" : "BlogRoles_roleTypeId",
          "type" : "DISPLAY_ENTITY",
          "title" : "",
          "imageLocation" : ""
        }, {
          "fieldHelpText" : "",
          "ajaxEnabled" : false,
          "size" : 0,
          "name" : "fromDate",
          "description" : "",
          "style" : "",
          "id" : "BlogRoles_fromDate",
          "title" : "",
          "type" : "DISPLAY",
          "imageLocation" : ""
        } ],
        "target" : ""
      }
]
